// Helper function to get the full image URL
// Remove trailing /api from the URL to get the base API server URL
const API_URL = import.meta.env.VITE_API_URL?.replace(/\/api$/, '') || 'http://localhost:5000';

export const getImageUrl = (imagePath) => {
    if (!imagePath) return '/logo.png'; // Default fallback

    // If it's already a full URL, return as is
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath;
    }

    // If it's a data URL, return as is
    if (imagePath.startsWith('data:')) {
        return imagePath;
    }

    // If it's a relative path starting with /uploads/, prepend API URL
    if (imagePath.startsWith('/uploads/')) {
        return `${API_URL}${imagePath}`;
    }

    // For any other relative path, return as is (might be from public folder)
    return imagePath;
};
